import { CustomError } from 'ts-custom-error';

export class ThemeAssertionError extends CustomError {
  public constructor() {
    // TODO: message about adding provider?
    super(`Expected theme but none was found.`);
  }
}
